// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"367":"b536a0f1","831":"bd904a5c"}[chunkId] || chunkId) + "." + {"367":"f645af04a6baa850","377":"3443c94518e40fb3","555":"4dccadaa68b6130f","584":"bd06a740d212ba93","831":"c71598d80690bf14","970":"eb51b92dc9ee8f27"}[chunkId] + ".js";
};